/* 测算相关接口 */
import http from "./request";

// 获取地区数据
export function getArea(params) {
	return http("/areaVoltage/list", {
		method: "GET",
		params: params
	});
}

// 单文件上传
export function uploadFile(params) {
	return http("/project/fileUpload", {
		method: "POST",
		params: params,
		headers: {
			"Content-Type": "multipart/form-data"
		}
	});
}

// 开始负载分析
export function startLoadAnalysis(params) {
	return http("/project/loadAnalysis", {
		method: "POST",
		params: params
	});
}

// 查询电量数据
export function getElectricData(id) {
	return http(`/project/elec/${id}`, {
		method: "GET",
		params: {}
	});
}

// 查询典型日数据
export function getTypicalData(id) {
	return http(`/project/typicalDay/${id}`, {
		method: "GET",
		params: {}
	});
}

// 保存下一步
export function saveNextStep(id) {
	return http(`/project/loadAnalysisNext/${id}`, {
		method: "GET",
		params: {}
	});
}
